import { defineStore } from 'pinia'

export const locales = [
  { locale: 'de_DE', currency: 'EUR', label: 'Deutschland' },
  { locale: 'de_AT', currency: 'EUR', label: 'Österreich' },
  { locale: 'de_CH', currency: 'CHF', label: 'Schweiz' },
]

export const useLocaleStore = defineStore('locale', {
  state: () => ({
    currentLocale: null,
  }),

  getters: {
    currentCountryCode: state => {
      return state.currentLocale.split('_')[1]
    },
  },

  actions: {
    initializeFromPath () {
      const path = window.location.pathname
      const match = path.match(/^\/(de_DE|de_AT|de_CH)(\/|$)/)
      let locale = locales[0]

      if (match) {
        locale = locales.find(({ locale }) => locale === match[1])
      }

      this.setLocale(locale)
    },

    setLocale (locale) {
      this.currentLocale = locale
    },
  },
})
